// extracted by mini-css-extract-plugin
export default {"userCard":"LuTbY1Ao"};